export default "<label>\n  {{label}}\n</label>\n<div>\n  {{value}}\n</div>\n";